import React from "react";
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import LayoutContainer, { LeftColumnContainer, RightColumnContainer } from "components/shared/containers/LayoutContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import CustomSelect, { CustomSelectItem } from "components/ui/CustomSelect";
import { UIPrimaryButton } from "components/ui/UIButton";
import UIDatePicker from "components/ui/UIDatePicker ";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function TransactionDownloadPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TransactionDownloadPage
 */
export default function TransactionDownloadPage(props) {
  return (
    <MainContentContainer className="transaction-download-page" header={<MainContentHeader text="Transaction Download" />}>
      <FormContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <FormRow>
              <UIDatePicker dateLabel="Start Date" allowPast={ true } allowFuture={ false } />
            </FormRow>
          </LeftColumnContainer>
          <RightColumnContainer>
            <FormRow>
              <UIDatePicker dateLabel="End Date" allowPast={ true } allowFuture={ false } />
            </FormRow>
          </RightColumnContainer>
        </LayoutContainer>
        <FormRow className="select-container">
          <CustomSelect label="File Type" >
            <CustomSelectItem value="CSV">CSV (Comma Separated Value)</CustomSelectItem>
            <CustomSelectItem value="QFX">QFX (QuickBooks Financial Exchange)</CustomSelectItem>
            <CustomSelectItem value="QBO">QBO (QuickBooks Online)</CustomSelectItem>
            <CustomSelectItem value="QIF">QIF (Quicken Interchange Format)</CustomSelectItem>
            <CustomSelectItem value="OFX">OFX (Open File Exchange, Microsoft & Others)</CustomSelectItem>
            <CustomSelectItem value="Excel">Excel (Microsoft Excel)</CustomSelectItem>
          </CustomSelect>
        </FormRow>
        <div className="flex-container flex-horizontal align-center-container information-text-container">
          <div className="set-width left-icon-container">
            <SVGAsset id="InformationIcon" className="information-icon" />
          </div>
          <div className="flex-width">
            <p className="sub-text">Your download will include all the posted transactions across all your cards associated with this account for the given date range.</p>
          </div>
        </div>
        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Download" />
          </DisabledPrompt>
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}